import type { GeneralConfig } from '@shared/types/Config';

export const countryConfig: GeneralConfig = {
    sortFieldMap: {},
};
